var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_vm._l(_vm.localMedicalCertificateParent.list, function (item, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "12"
      }
    }, [_c('MedicalCertificateDocComponent', {
      attrs: {
        "index": i,
        "item": item
      },
      on: {
        "set-data": function setData($event) {
          return _vm.setMedicalCertificate($event, item);
        },
        "remove": function remove($event) {
          return _vm.removeMedicalCertificate(item);
        }
      }
    })], 1);
  }), !_vm.localMedicalCertificateParent.list.length ? _c('v-col', {
    staticClass: "d-flex justify-end pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "rounded": ""
    },
    on: {
      "click": _vm.addMedicalCertificate
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus ")]), _vm._v(" Добавить медицинскую справку ")], 1)], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }